export class InvalidImageError extends Error {
	constructor(message?: string, public invalidImage?: any) {
		super(message);
	}
}

export function isInvalidImageError(error: InvalidImageError): error is InvalidImageError {
	return error.invalidImage !== undefined;
}
